import CryptoJS from "crypto-js";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const Per_Page_Dropdown = async (data) => {
  const a = [];
  for (let i = 5; i <= data; i *= 2) {
    a.push(i);
  }
  a.push(data);

  return a;
};

export const RequiredIs = {
  roles: [1, 2, 3, 4, 5, 6, 7],
};

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const getDimension = async (file) => {
  let reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      var image = new Image();
      image.src = reader.result;
      image.onload = function () {
        resolve({ width: this.width, height: this.height });
      };
    };
    reader.readAsDataURL(file);
  });
};

export const formatDate = (dateString) => {
  const parsedDate = new Date(dateString);

  if (isNaN(parsedDate)) {
    return "Invalid date";
  }

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
  const day = String(parsedDate.getDate()).padStart(2, "0");

  return `${day}-${month}-${year}`;
}
export const formatTime = (time) => {
  if (!time) return "";

  const [hours, minutes] = time.split(":");
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);

  return date.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};
export const formatEncodedTime = (timeObj) => {
  let date;

  // If it's a Moment or Day.js object
  if (timeObj?.toDate && typeof timeObj.toDate === "function") {
    date = timeObj.toDate();
  }
  // If it's a raw JS Date object
  else if (timeObj instanceof Date) {
    date = timeObj;
  }
  // If it's a string, try to parse it
  else if (typeof timeObj === "string") {
    date = new Date(timeObj);
  }
  // If it's an object with a $d property (Day.js-like)
  else if (timeObj?.$d instanceof Date) {
    date = timeObj.$d;
  }

  if (!date || isNaN(date.getTime())) {
    return "Invalid time";
  }

  return new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
};

export const formatEncodedDateTime = (timeObj) => {
  let date;

  // If it's a Moment or Day.js object
  if (timeObj?.toDate && typeof timeObj.toDate === "function") {
    date = timeObj.toDate();
  }
  // If it's a raw JS Date object
  else if (timeObj instanceof Date) {
    date = timeObj;
  }
  // If it's a string, try to parse it
  else if (typeof timeObj === "string") {
    date = new Date(timeObj);
  }
  // If it's an object with a $d property (Day.js-like)
  else if (timeObj?.$d instanceof Date) {
    date = timeObj.$d;
  }

  if (!date || isNaN(date.getTime())) {
    return "Invalid time";
  }

  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
};


export const formatAmount = (amount = 0) => {
  return `₹ ${new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0)}`;
};



export const RegxExpression = {
  name: /[A-Z-a-z ]/,
  email:
    /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
  phone: /[0-9]/,

  ifsc: "^[A-Z]{4}[0][dA-Z]{6}$",
  ifsc_code: /^[A-Z0-9]$/,
  micr: /^[0-9]{9}$/,
  bank_number: /^\d{0,14}$/,
  gst: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[1-9A-Z]{1}$/,
};


const SECRET_KEY = "INFINITYLADAKH";
export const encodeId = (id) => {
  if (!id) return "";
  const ciphertext = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
  return encodeURIComponent(ciphertext); // Make URL-safe
};

export const decodeId = (encodedId) => {
  if (!encodedId) return "";
  try {
    const decoded = decodeURIComponent(encodedId);
    const bytes = CryptoJS.AES.decrypt(decoded, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Invalid ID decryption:", error);
    return error;
  }
};


export const timeAgoOrDate = (date) => {
  if (!date) return "";

  const now = dayjs();
  const inputDate = dayjs(date);

  const diffInHours = now.diff(inputDate, "hour");

  // ⏱️ Less than 24 hours → show relative time
  if (diffInHours < 24) {
    return inputDate.fromNow();
  }

  // 📅 More than 1 day → show formatted date
  return inputDate.format("DD MMM YYYY");
};

export const formatViews = (views = 0) => {
  if (views < 1_000) {
    return views.toLocaleString();
  }

  if (views < 1_000_000) {
    return (views / 1_000).toFixed(1).replace(".0", "") + "K";
  }

  if (views < 1_000_000_000) {
    return (views / 1_000_000).toFixed(1).replace(".0", "") + "M";
  }

  return (views / 1_000_000_000).toFixed(1).replace(".0", "") + "B";
};
